var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.header))]),_c('h6',{staticStyle:{"color":"grey"}},[_vm._v(" "+_vm._s(_vm.subHeader)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }